module.exports = __webpack_public_path__ + "img/category1.4fb5e170.svg";